import React from "react";

import DtvButton, { IDtvButtonProps, IDtvButtonAnalytics } from "@directv-digital/dds.ui.dtv-button";
import Tooltip, { FusionTooltipProps } from "@directv-digital/fusion.molecules.tooltip";
import DtvTypography from "@directv-digital/dds.ui.dtv-typography";
import { validContent } from "@directv-digital/dds.utils";
import { TypographyProps } from "@mui/material/Typography";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

interface IPosition {
  position?: "inline" | "block";
}

export interface IDtvTextProps extends TypographyProps {
  content?: string;
  tooltip?: FusionTooltipProps & IPosition;
  cta?: IDtvButtonProps & IPosition;
  component?: React.ElementType;
  inlineLinkStyle?: any;
  variant?: any;
  color?: string;
  font?: string;
  fontFamily?: string;
  fontSize?: string;
  style?: any;
  sx?: any;
  isCartIconDrawer?: boolean;
  preventCtaAnalytics?:boolean;
  analytics?: IDtvButtonAnalytics;
  richTextLinkClick?:(event? : any) => void;
}

export function DtvText({
  content,
  tooltip,
  cta,
  sx,
  inlineLinkStyle,
  preventCtaAnalytics,
  analytics,
  richTextLinkClick,
  ...otherProps
}: IDtvTextProps) {
  try {
    const { position: tooltipPosition, ...otherTooltipProps } = tooltip || {};
    const { position: ctaPosition, ...otherCtaProps } = cta || {};
    const contentProps: any = {};
    if (cta?.content) {
      contentProps.content = cta.content;
    }

    return (
      <DtvTypography
        sx={{
          "& sup": {
            verticalAlign: "top",
            lineHeight: "100%"
          },
          ...(tooltip?.content && tooltipPosition !== "block" ?
            {
                display: "inline-block",
                alignItems: "center"
              } :
            null),
          ...sx
        }}
        {...otherProps}
      >
        {content ?
          validContent(content.trim(), Tooltip, DtvButton, preventCtaAnalytics ? undefined : analytics, richTextLinkClick) :
          null}

        {tooltip?.content && (
          <Tooltip
            {...otherTooltipProps}
            PopperProps={{
              sx: {
                "& .MuiTypography-root": {
                  fontFamily: `roboto-regular`,
                  fontSize: "14px"
                }
              }
            }}
            sx={{ ...tooltip.sx }}
          />
        )}
        {cta?.label && (
          <DtvButton
            role="button"
            variant="uxtext"
            sx={{
              "&:focus": {
                outline: "none"
              },
              ...(ctaPosition !== "block" ?
                {
                    display: "inline-flex",
                    verticalAlign: "baseline",
                    ml: 1,
                    fontFamily: "inherit",
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    lineHeight: "inherit",
                    // margin: "inherit",
                    letterSpacing: "inherit",
                    ...inlineLinkStyle
                  } :
                {
                    display: "block",
                    ...inlineLinkStyle
                  })
            }}
            {...((cta?.legalText?.content || cta?.legalUrl) && {
              modalType: "legal",
              modalData: {
                id: cta?.id,
                content: cta?.legalText?.content,
                url: cta?.legalUrl
              }
            })}
            {...otherCtaProps}
          />
        )}
      </DtvTypography>
    );
  } catch (error) {
    return <ErrorDisplay component="DTV Text" error={error} />;
  }
}
